import * as React from "react";
import styled from "styled-components";
import { useFormikContext, Field } from "formik";
import { Checkbox } from "components/bootstrap";
import { FormikFormGroup, HoverForHelp } from "components/common";
import { DateType, ValuesType } from "views/logic/aggregationbuilder/Pivot";
import Direction from "./configuration/Direction";
import FieldComponent from "./configuration/FieldComponent";
import Time from "./configuration/Time";
const Wrapper = styled.div``;
const SkipEmptyValuesHoverForHelp = styled((props) => /* @__PURE__ */ React.createElement(HoverForHelp, { ...props }))`
  margin-left: 5px;
`;
const SkipEmptyValuesCheckbox = styled(Checkbox)`
  &.checkbox {
    padding-top: 0;
  }
`;
const SkipEmptyValuesLabel = styled.div`
  display: flex;
  align-items: center;
`;
const SkipEmptyValues = ({ index }) => /* @__PURE__ */ React.createElement(Field, { name: `groupBy.groupings.${index}.skipEmptyValues` }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(SkipEmptyValuesCheckbox, { onChange: () => onChange({ target: { name, value: !value } }), checked: value != null ? value : false }, /* @__PURE__ */ React.createElement(SkipEmptyValuesLabel, null, "Skip Empty Values", /* @__PURE__ */ React.createElement(SkipEmptyValuesHoverForHelp, { title: "Skip Empty Values" }, "When this is enabled, messages which do not contain the configured fields will be skipped.", /* @__PURE__ */ React.createElement("p", null), 'Otherwise an "(Empty Value)" bucket will be created.'))));
const GroupingConfiguration = React.memo(({ index }) => {
  const {
    values: { groupBy }
  } = useFormikContext();
  const fieldType = groupBy.groupings[index].type;
  return /* @__PURE__ */ React.createElement(Wrapper, { "data-testid": `grouping-${index}` }, /* @__PURE__ */ React.createElement(Direction, { groupingIndex: index }), /* @__PURE__ */ React.createElement(FieldComponent, { groupingIndex: index }), fieldType === DateType && /* @__PURE__ */ React.createElement(Time, { index }), fieldType === ValuesType && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormikFormGroup, { label: "Limit", name: `groupBy.groupings.${index}.limit`, type: "number", bsSize: "small" }), /* @__PURE__ */ React.createElement(SkipEmptyValues, { index })));
});
export default GroupingConfiguration;
